var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"temp"},[_c('br'),_c('br'),_c('br'),_c('br'),_c('v-layout',{attrs:{"text-center":"","wrap":""}},[_c('v-flex',{attrs:{"mb-5":"","xs12":""}},[_c('h1',[_vm._v("Redirecting")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }